import { render, staticRenderFns } from "./TrainingVideoUpload.vue?vue&type=template&id=695ce6ff"
import script from "./TrainingVideoUpload.vue?vue&type=script&lang=js"
export * from "./TrainingVideoUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports